export class TabsSection{
	init(){
		var $tabsSections = $('.cms-section[data-tabs="true"]');
		if($tabsSections.length){
			$tabsSections.each(function(tabsSectionId, tabsSection){
				var $tabsSection 			= $(tabsSection),
						$tabsSectionItems = $tabsSection.find('.section-tab'),
						tabsNames 				= [];
				
				var $tabsSectionButtons = $('<div />', {'class': 'section-tabs__buttons'}).append( $('<ul />') );
				$tabsSectionItems.each(function(sectionItemId, sectionItem){
					var $sectionItem = $(sectionItem);
					var $tabButton = $('<button />', {'class': 'section-tabs__button js-section-tabs-button', 'data-id': $sectionItem.attr('id')}).html($sectionItem.data('tab-name'));
					
					if(sectionItemId != 0)
						$sectionItem.hide();
					else
						$tabButton.addClass('active');

					$tabsSectionButtons.find('ul').append($('<li />').append($tabButton));
				});
				$tabsSection.find('.s-content').prepend($tabsSectionButtons);
			});
		}

		this.actions();
	}

	actions(){
		$('.js-section-tabs-button').on('click', function(e){
			var $tabButton 			= $(this),
					$tabId 					= $tabButton.data('id'),
					$parentSection 	= $tabButton.closest('.cms-section');

			if(!$tabButton.hasClass('active')){
				$parentSection.find('.section-tab').fadeOut(300);
				$parentSection.find('.section-tabs__button').removeClass('active');

				setTimeout(function(){
					$tabButton.addClass('active');
					$('#'+$tabId).fadeIn();
				}, 300);
					
			}
		});
	}
}